<template>
    <div class="menuContainer" role="navigation">
        <div class="pandoraMenu">
            <MenuItem @click="item.action? item.action(): undefined" :text="item.title" v-for="(item, index) in props.menuitems" :key="`menu-${index}`" :titleactive="props.titleactive">
            <div class="pandoraMenu" v-if="item.submenu">
                <MenuItem style="z-index: 10000 !important;" @click="item2.action? item2.action(): undefined" :text="item2.title" v-for="(item2, index2) in item.submenu" :key="`menu2-${index2}`">
                <div class="pandoraMenu" v-if="item2.submenu">
                    <MenuItem style="z-index: 10000 !important;" @click="item3.action? item3.action(): undefined" :text="item3.title" v-for="(item3, index3) in item2.submenu" :key="`menu3-${index3}`">
                    <div class="pandoraMenu" v-if="item3.submenu">
                        <MenuItem style="z-index: 10000 !important;" @click="item4.action? item4.action(): undefined" :text="item4.title" v-for="(item4, index4) in item3.submenu" :key="`menu4-${index4}`">
                        </MenuItem>
                    </div>
                    </MenuItem>
                </div>
                </MenuItem>
            </div>
            </MenuItem>
        </div>
    </div>
</template>

<script setup>
import MenuItem from '../menuItem/MenuItem.vue';

import { defineProps } from 'vue';

const props = defineProps({
    titleactive: {
        type: String,
        default: ''
    },
    menuitems: {
        default: []
    }
});
</script>

<style scoped>
body * {
    margin: 0;
    padding: 0;
}

.menuContainer>.pandoraMenu {
    display: ruby;
}

.menuContainer .pandoraMenuitem>.pandoraMenu {
    position: absolute;
    pointer-events: none;
}

.pandoraMenuitem:hover>.pandoraMenu {
    pointer-events: initial;
}

.menuContainer>.pandoraMenu>.pandoraMenuitem .pandoraMenuitem .pandoraMenu {
    transform: translateX(100%);
    top: 0;
    right: 0;
}
</style>